import { render, staticRenderFns } from "./ColorField.vue?vue&type=template&id=361aaa0d&"
import script from "./ColorField.vue?vue&type=script&lang=ts&"
export * from "./ColorField.vue?vue&type=script&lang=ts&"
import style0 from "./ColorField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports